import { render, staticRenderFns } from "./selectTranslatedArray.vue?vue&type=template&id=bd071b46&scoped=true"
import script from "./selectTranslatedArray.vue?vue&type=script&lang=js"
export * from "./selectTranslatedArray.vue?vue&type=script&lang=js"
import style1 from "./selectTranslatedArray.vue?vue&type=style&index=1&id=bd071b46&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd071b46",
  null
  
)

export default component.exports